import { useNavigate } from "react-router-dom";
import { Button } from "@/components";
import { openModal } from "react-url-modal";
import { getTokenFromStorage } from "@/utils";
import { useAppDispatch } from "@/redux/store";
import { openAuthModal } from "@/utils/authModal/openAuthModal";
import styles from "./EmptyGameList.module.scss";
import emptyGameListIcon from "@/assets/img/emptyGameListIcon.svg";

interface EmptyGameListProps {
  title?: string;
  description?: string;
  buttonText?: string;
  onButtonClick?: () => void;
  buttonNavigateTo?: string;
  showButton?: boolean;
}

export const EmptyGameList: React.FC<EmptyGameListProps> = ({
  title = "Ой, список ваших игр пуст!",
  description = "Чтобы добавить игру, создайте её, используя кнопку ниже или отправьте заявку на участие в других играх в разделе «Доступные игры»",
  buttonText = "Создать игру",
  onButtonClick,
  buttonNavigateTo,
  showButton = true,
}) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleButtonClick = () => {
    if (onButtonClick) {
      onButtonClick();
    } else if (buttonNavigateTo) {
      navigate(buttonNavigateTo);
    } else {
      const token = getTokenFromStorage();
      if (!token) {
        openAuthModal(dispatch);
      } else {
        openModal({ name: "createNewGame" });
      }
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.contentWrapper}>
        <div className={styles.image}>
        <img src={emptyGameListIcon} alt="empty game list icon" />
        </div>

        <div className={styles.textWrapper}>
          <p className={styles.title}>
            {title}
          </p>
          
          <p className={styles.description}>
            {description}
          </p>
        </div>
        
        {showButton && (
          <Button
            newStyles={styles.button}
            onClickFunc={handleButtonClick}
          >
            <span>
              {buttonText}
            </span>
          </Button>
        )}
      </div>
    </div>
  );
};